module.exports = __webpack_public_path__ + "img/46.6.CODm.f5b9b215.png";